import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { DateService, TextService } from "@src/services";
import { normalize } from "@src/utils";

export const useMonths = () => {
  const i18n = useI18n();

  const months = computed(() => {
    const items = [0, 1, 2].map((index) => ({
      id: `month_${index}`,
      title: TextService.capitalize(DateService.getMonthNameByOffset(index, i18n.locale.value)),
      subtitle: index === 0 ? i18n.t("Текущий месяц") : undefined,
    }));

    return normalize(items, "id");
  });

  return months;
};
